(() => {
 'use strict';
 const $ = (selector, root = document) => root.querySelector(selector);
 const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
 const root = document.body.dataset.root || '/';
 const ordering = document.body.dataset.ordering === 'true';
 const currency = document.body.dataset.currency || 'USD';
 const money = (cents, code = currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:code}).format(cents / 100);
 const announce = text => { const node = $('[data-global-status]'); if (node) node.textContent = text; };
 function openDialog(dialog, trigger) {
  if (!dialog) return;
  dialog.returnFocus = trigger || document.activeElement;
  if (!dialog.open) dialog.showModal();
 }
 function closeDialog(dialog) { if (!dialog) return; dialog.close(); dialog.returnFocus?.focus(); }
 document.addEventListener('click', event => {
  const close = event.target.closest('[data-close-dialog]');
  if (close) closeDialog(close.closest('dialog'));
  const contact = event.target.closest('[data-contact]');
  if (contact) {
   const dialog = $('#ContactDialog');
   const tracking = contact.dataset.contact === 'tracking';
   $('[data-tracking-intro]', dialog).hidden = !tracking;
   $('[data-contact-intro]', dialog).hidden = tracking;
   $$('details.mobile-menu[open]').forEach(menu => menu.open = false);
   openDialog(dialog, contact);
  }
  if (event.target.tagName === 'DIALOG') {
   const r = event.target.getBoundingClientRect();
   if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
  }
 });
 if ($('#ContactDialog [data-contact-success]') || location.hash === '#ContactPanelForm' || $('#ContactPanelForm .errors')) openDialog($('#ContactDialog'));

 function setupProduct(section) {
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = 'true';
  const variants = JSON.parse($('[data-variants]',section).textContent);
  const demo = section.dataset.demo === 'true';
  const format = cents => money(cents, demo ? 'USD' : currency);
  let selected = variants.find(v => String(v.id) === $('[data-variant-id].is-active',section)?.dataset.variantId) || variants[0];
  let quantity = Number($('[data-quantity-card]',section)?.dataset.quantityCard || 1);
  let busy = false;
  const form = $('.product-form',section);
  const sticky = $('[data-sticky-atc]',section);
  const media = $$('.gallery-slide',section);
  const card = () => $(`[data-quantity-card="${quantity}"]`,section);
  const selectedVariants = () => card() ? $$('[data-bundle-slot]',card()).map(select => variants.find(v => String(v.id) === select.value)) : [selected];
  const usable = () => selectedVariants().every(v => v?.available);
  const totals = options => {
   const total = options.reduce((sum,v) => sum + (v?.price || 0),0);
   const original = options.reduce((sum,v) => sum + Math.max(v?.compare_at_price || 0,v?.price || 0),0);
   const saving = original-total;
   return {original,saving,total,percent:original ? Math.round(saving/original*100) : 0};
  };
  const extras = () => $$('[data-addon]:checked',section);
  const paidAddons = () => card() ? $$('[data-paid-addon]:checked',card()) : [];
  const freeAddons = () => card() ? $$('[data-free-addon-variant]',card()) : [];
  const extrasTotal = () => [...extras(), ...paidAddons()].reduce((sum,input) => sum+Number(input.dataset.addonPrice || 0),0);
  function showMedia(id) {
   if (!media.some(el => el.dataset.mediaId === String(id))) return;
   media.forEach(el => {
    const active = el.dataset.mediaId === String(id);
    el.hidden = !active; el.classList.toggle('is-active',active);
    if (!active) $$('video',el).forEach(video => video.pause());
   });
   $$('[data-media-target]',section).forEach(el => {
    const active = el.dataset.mediaTarget === String(id);
    el.classList.toggle('is-active',active);el.setAttribute('aria-pressed',String(active));
   });
  }
  function updateTotals() {
   $$('.quantity-card',section).forEach(el => {
    const options = $$('[data-bundle-slot]',el).map(select => variants.find(v => String(v.id) === select.value));
    const amounts = totals(options);
    $('[data-quantity-price]',el).textContent = format(amounts.total);
    const save = $('[data-bundle-save]',el);
    if (save) {save.hidden=amounts.saving===0;save.textContent=`SAVE ${amounts.percent}%`;}
    const original = $('[data-bundle-original]',el);
    if(original) {original.hidden=amounts.saving===0;original.textContent=format(amounts.original);}
   });
   const total = totals(selectedVariants()).total + extrasTotal();
   $('[data-sticky-price]',section).textContent = format(total);
   const totalLabel = $('[data-selected-total]',section);
      if(totalLabel){
    totalLabel.hidden = extras().length === 0 && paidAddons().length === 0;
    totalLabel.textContent = `Selected total: ${format(total)}`;
   }
   const disabled = !ordering || demo || !usable() || busy;
   const label = busy ? 'Adding…' : !ordering || demo ? 'Coming soon' : !usable() ? 'Sold out' : 'Add to cart';
   $$('[data-add-button],[data-sticky-add]',section).forEach(button => { button.disabled = disabled; button.textContent = label; });
  }
  function chooseVariant(id, updateUrl = true) {
   const variant = variants.find(v => String(v.id) === String(id));
   if (!variant) return;
   selected = variant;
   const variantLabel = $('[data-variant-label]',section); if(variantLabel) variantLabel.textContent = variant.title;
   const unitPrice = $('[data-unit-price]', section);
if (unitPrice) unitPrice.textContent = format(variant.price);
   const compare = $('[data-compare-price]',section);
   const badge = $('[data-sale-badge]',section);
   const sale = variant.compare_at_price > variant.price;
   if(compare) compare.hidden = !sale; if(badge) badge.hidden = !sale;
   if (sale && compare && badge) {compare.textContent = format(variant.compare_at_price);badge.textContent = `SAVE ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;}
   $$('[data-variant-id]',section).forEach(button => {const active = button.dataset.variantId === String(id);button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
   $$('[data-bundle-slot="1"]',section).forEach(select => select.value = String(id));
   const master = $('[data-master-variant]',section); if(master) master.value = String(id);
   $('[data-sticky-variant]',section).value = String(id);
   const fallbackMedia = /peppermint/i.test(variant.title) ? 'red' : /dasher/i.test(variant.title) ? 'brown' : variant.title.toLowerCase();
   showMedia(variant.featured_media?.id || fallbackMedia);
   const stock = $('[data-stock-notice]',section);
   if(stock){const low=stock.dataset.stockEnabled==='true' && variant.inventory_management && variant.inventory_policy==='deny' && variant.available && variant.inventory_quantity>0 && variant.inventory_quantity<=Number(stock.dataset.stockThreshold);stock.hidden=!low;stock.textContent=low?`LIMITED STOCK | ${variant.inventory_quantity} ${variant.inventory_quantity===1?'BED':'BEDS'} LEFT`:'';}
   if (updateUrl && !demo && location.pathname.includes('/products/')) { const url = new URL(location.href); url.searchParams.set('variant',id); history.replaceState({},'',url); }
   updateTotals();
  }
  section.addEventListener('click',event => {
   const variantButton = event.target.closest('[data-variant-id]'); if(variantButton) chooseVariant(variantButton.dataset.variantId);
   const quantityButton = event.target.closest('[data-quantity]');
   if(quantityButton) {
    quantity = Number(quantityButton.dataset.quantity);
    $$('.quantity-card',section).forEach(el => {const active = Number(el.dataset.quantityCard) === quantity;el.classList.toggle('is-active',active);$('.bundle-options',el).hidden = !active;$('[data-quantity]',el).setAttribute('aria-pressed',String(active));});
    const input = $('[data-master-quantity]',section);if(input) input.value = quantity;
    updateTotals();
   }
   const thumb = event.target.closest('[data-media-target]'); if(thumb) showMedia(thumb.dataset.mediaTarget);
   const step = event.target.closest('[data-gallery-step]');
   if(step && media.length) { const index = media.findIndex(el => !el.hidden);showMedia(media[(index + Number(step.dataset.galleryStep) + media.length) % media.length].dataset.mediaId); }
   const zoom = event.target.closest('.zoom-trigger');
   if(zoom) { const source = $('img',zoom);const dialog = $('.image-dialog',section);const image = $('img',dialog);image.src = source.currentSrc || source.src;image.alt = source.alt;openDialog(dialog,zoom); }
   if(event.target.closest('[data-sticky-add]')) form?.requestSubmit();
  });
  section.addEventListener('change',event => {
   if(event.target.matches('[data-addon],[data-paid-addon]')) updateTotals();
   if(event.target.matches('[data-sticky-variant]')) chooseVariant(event.target.value);
   if(event.target.matches('[data-bundle-slot]')) { if(event.target.dataset.bundleSlot === '1') chooseVariant(event.target.value); else updateTotals(); }
   if(event.target.matches('[data-master-variant]')) chooseVariant(event.target.value);
  });
  form?.addEventListener('submit',async event => {
   event.preventDefault(); if(busy || !ordering || demo || !usable()) return;
   busy = true;updateTotals();
   const message = $('[data-product-message]',section);message.textContent = '';
   const items = selectedVariants().map(v => ({
    id:v.id,
    quantity:1,
    properties:{'_bundle_bed':'true','_bundle_size':String(quantity)}
   }));
   const selectedExtras = [
    ...extras().filter(input => input.dataset.addonReal==='true').map(input=>({
     id:Number(input.value),quantity:1,properties:{'_bundle_addon':'true'}
    })),
    ...paidAddons().map(input=>({
     id:Number(input.value),quantity:1,properties:{'_bundle_addon':'true'}
    }))
   ];
   const selectedGifts = freeAddons().map(row=>({
    id:Number(row.dataset.freeAddonVariant),
    quantity:1,
    properties:{'_auto_gift':'true','_gift_minimum':String(quantity)}
   }));
   $$('[data-addon],[data-paid-addon]',section).forEach(input=>input.disabled=true);
   try {
    const cartResponse=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
    if(!cartResponse.ok)throw new Error('Please check your bag before adding your selection.');
    const existing=await cartResponse.json();
    const existingVariantIds=new Set(existing.items.map(item=>String(item.variant_id || item.id)));
    items.push(...selectedExtras.filter(extra=>!existingVariantIds.has(String(extra.id))));
    items.push(...selectedGifts.filter(gift=>!existingVariantIds.has(String(gift.id))));
    const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data = await response.json();
    if(!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This item could not be added. Please check availability.');
    announce('Added to your bag.');
    // Do not repeat an add if refreshing the cart fails: the order may already be in it.
    await loadCart(true, $('[data-add-button]',section));
   } catch(error) { message.textContent = error.message || 'Please check your bag before trying again.'; }
   finally { busy = false;$$('[data-addon],[data-paid-addon]',section).forEach(input=>input.disabled=false);updateTotals(); }
  });
  if('IntersectionObserver' in window) {
   const target = $('.add-button',section);
   const observer = new IntersectionObserver(entries => {
    const entry = entries[0]; const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    sticky.hidden = !show;document.body.classList.toggle('has-sticky',show);
   },{threshold:0});
   if(target) observer.observe(target);
   section._observer = observer;
  }
  $$('.quantity-card',section).forEach(el => {const active=Number(el.dataset.quantityCard)===quantity;el.classList.toggle('is-active',active);$('.bundle-options',el).hidden=!active;$('[data-quantity]',el).setAttribute('aria-pressed',String(active));});
  section.addEventListener('shopify:block:select',event => {const button=$('[data-quantity]',event.target);if(button) button.click();});
  chooseVariant(selected.id,false);
 }

 const cartDialog = $('#CartDrawer');
 let cartBusy = false;
 function element(tag,className,text) { const el = document.createElement(tag);if(className) el.className = className;if(text !== undefined) el.textContent = text;return el; }
  const cartProductCache = new Map();

 async function getCartProduct(handle, cartCurrency) {
  if (!handle) return null;

  const cacheKey = `${cartCurrency}:${handle}`;

  if (!cartProductCache.has(cacheKey)) {
   const request = fetch(
    `${root}products/${encodeURIComponent(handle)}.js`,
    { headers: { Accept: 'application/json' } }
   )
    .then(response => {
     if (!response.ok) throw new Error('Product unavailable');
     return response.json();
    })
    .catch(() => {
     cartProductCache.delete(cacheKey);
     return null;
    });

   cartProductCache.set(cacheKey, request);
  }

  return cartProductCache.get(cacheKey);
 }

 async function renderCart(cart) {
  const savingsRow = $('[data-cart-savings-row]', cartDialog);
  const savingsValue = $('[data-cart-savings]', cartDialog);

  // Hide the previous amount while calculating the updated cart.
  if (savingsRow) savingsRow.hidden = true;

  const originalTotals = await Promise.all(
   cart.items.map(async item => {
    const originalLine = Number(
     item.original_line_price ?? item.final_line_price ?? 0
    );

    // Subscription pricing needs its own comparison logic.
    if (item.selling_plan_allocation) return originalLine;

    const product = await getCartProduct(item.handle, cart.currency);
    const variant = product?.variants?.find(
     variant => String(variant.id) === String(item.variant_id)
    );

    const compareAt = Number(variant?.compare_at_price || 0);
    const variantPrice = Number(variant?.price || 0);
    const quantity = Number(item.quantity || 0);

    if (compareAt <= variantPrice) return originalLine;

    return Math.max(originalLine, compareAt * quantity);
   })
  );

  const originalTotal = originalTotals.reduce(
   (sum, amount) => sum + amount,
   0
  );

  const savings = Math.max(
   0,
   originalTotal - Number(cart.total_price || 0)
  );

  if (savingsRow && savingsValue) {
   savingsValue.textContent = `−${money(savings, cart.currency)}`;
   savingsRow.hidden = savings === 0 || cart.item_count === 0;
  }
  $$('[data-cart-count]').forEach(node => {node.textContent = cart.item_count;node.hidden = cart.item_count === 0;});
  $('[data-drawer-count]',cartDialog).textContent = `(${cart.item_count})`;
    $('[data-cart-subtotal]',cartDialog).textContent = money(cart.total_price,cart.currency);
  const checkout = $('[data-drawer-checkout]',cartDialog);if(checkout) checkout.disabled = cart.item_count === 0;
  const container = $('[data-cart-items]',cartDialog);container.replaceChildren();
  if(!cart.items.length) {const empty = element('div','empty-cart');empty.append(element('h3','','Your bag is empty'),element('p','','Find a little Christmas magic for your best friend.'));container.append(empty);return;}
    cart.items.forEach((item, index) => {
   const row = element('article','drawer-item');
   if(item.image) {const img = element('img');img.src = item.image;img.alt = item.product_title;img.width=85;img.height=85;row.append(img);}
   const info = element('div'); const title = element('h3');const link = element('a','',item.product_title);link.href = item.url;title.append(link);info.append(title);
   if(item.variant_title) info.append(element('p','',item.variant_title));
   if(item.properties) Object.entries(item.properties).forEach(([key,value]) => {if(value && !key.startsWith('_')) info.append(element('p','',`${key}: ${value}`));});
   (item.line_level_discount_allocations || []).forEach(d => info.append(element('p','',d.discount_application.title)));
      const currentPrice = Number(item.final_line_price || 0);
   const originalPrice = originalTotals[index] ?? currentPrice;
   const itemSaving = Math.max(0, originalPrice - currentPrice);

   const priceBox = element('div', 'drawer-price-box');
   const priceLine = element('div', 'drawer-price-line');

   if (itemSaving > 0) {
    priceLine.append(
     element('s', 'drawer-original-price', money(originalPrice, cart.currency))
    );
   }

   const isGift = item.properties?._auto_gift === 'true';
   priceLine.append(
    element('strong', 'drawer-current-price',
     isGift && currentPrice === 0 ? 'FREE' : money(currentPrice, cart.currency))
   );

   priceBox.append(priceLine);

   if (itemSaving > 0) {
    priceBox.append(
     element('span', 'drawer-item-saving',
      `(You save ${money(itemSaving, cart.currency)})`)
    );
   }
   const controls = element('div','drawer-item-controls');
   const stepper = element('div','quantity-stepper');
   if (isGift) {
    stepper.classList.add('quantity-stepper--gift');
    stepper.append(element('span','','Included'));
   } else {
    const minus = element('button','','−');minus.type='button';minus.setAttribute('aria-label',`Decrease ${item.product_title} ${item.variant_title || ''} quantity`);
    const plus = element('button','','+');plus.type='button';plus.setAttribute('aria-label',`Increase ${item.product_title} ${item.variant_title || ''} quantity`);
    minus.addEventListener('click',()=>changeCart(item.key,item.quantity-1));plus.addEventListener('click',()=>changeCart(item.key,item.quantity+1));
    stepper.append(minus, element('span', '', item.quantity), plus);
   }

   const remove = element('button', 'remove-button', 'Remove');
   remove.type = 'button';
   remove.setAttribute(
    'aria-label',
    `Remove ${item.product_title} ${item.variant_title || ''}`
   );
   remove.addEventListener('click', () => changeCart(item.key, 0));

   controls.append(stepper, priceBox, remove);
   info.append(controls);
   row.append(info);
   container.append(row);
  });
 }
 async function loadCart(open = false, trigger) {
  if(open) openDialog(cartDialog,trigger);
  const message = $('[data-cart-message]',cartDialog);message.textContent = 'Loading your bag…';
  try {
   const response = await fetch(`${root}cart.js`, {
    headers: { Accept: 'application/json' }
   });

   if (!response.ok) {
    throw new Error('Could not refresh your bag. Please close it and try again.');
   }

   await renderCart(await response.json());
   message.textContent = '';
  }
    catch(error) {
   message.textContent = error.message ||
    'Could not load your bag. Please close it and try again.';
  }
 }
 async function changeCart(key,quantity) {
  if(cartBusy) return;cartBusy=true;
  const message = $('[data-cart-message]',cartDialog);message.textContent = '';
  const focusText = document.activeElement?.getAttribute('aria-label');
  $$('button',cartDialog).filter(el => !el.matches('[data-close-dialog]')).forEach(el=>el.disabled=true);
  try {
   const response = await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});const data = await response.json();
   if(!response.ok) throw new Error(data.description || data.message || 'Unable to change this quantity.');
      await renderCart(data);
   announce('Bag updated.');
   const target = $$('button',cartDialog).find(el => el.getAttribute('aria-label') === focusText);(target || $('[data-close-dialog]',cartDialog)).focus();
  } catch(error) {message.textContent = error.message || 'Unable to update your bag.';}
  finally {cartBusy=false;$$('.drawer-item-controls button',cartDialog).forEach(el=>el.disabled=false);const checkout=$('[data-drawer-checkout]',cartDialog);if(checkout)checkout.disabled=!$('.drawer-item',cartDialog);}
 }
 document.addEventListener('click',event=>{const trigger=event.target.closest('[data-cart-open]');if(trigger){event.preventDefault();loadCart(true,trigger);}});
 $$('[data-product-section]').forEach(setupProduct);
 document.addEventListener('shopify:section:load',event=>{$$('[data-product-section]',event.target).forEach(setupProduct);});
 document.addEventListener('shopify:section:unload',event=>{$$('[data-product-section]',event.target).forEach(section=>section._observer?.disconnect());});

 /* Real countdown — only runs if a genuine end date/time was set in the Top promotion section */
 $$('[data-countdown-end]').forEach(el => {
  const end = new Date(el.dataset.countdownEnd).getTime();
  if (Number.isNaN(end)) { el.hidden = true; return; }
  const pad = n => String(n).padStart(2, '0');
  function tick() {
   const diff = end - Date.now();
   if (diff <= 0) { el.textContent = 'Sale ended'; clearInterval(timer); return; }
   const d = Math.floor(diff / 86400000);
   const h = Math.floor((diff % 86400000) / 3600000);
   const m = Math.floor((diff % 3600000) / 60000);
   const s = Math.floor((diff % 60000) / 1000);
   const days = $('[data-cd-days]', el); if (days) days.textContent = pad(d);
   const hours = $('[data-cd-hours]', el); if (hours) hours.textContent = pad(h);
   const mins = $('[data-cd-minutes]', el); if (mins) mins.textContent = pad(m);
   const secs = $('[data-cd-seconds]', el); if (secs) secs.textContent = pad(s);
  }
  tick();
  const timer = setInterval(tick, 1000);
 });
})();


(() => {
  const selector = 'video[data-paws-auto-video]';
  const videos = new Map();
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function update(video) {
    const visible = videos.get(video);

    if (document.hidden || !visible) {
      video.pause();
      return;
    }

    // Let visitors who request reduced motion start playback themselves.
    if (reducedMotion.matches) return;

    video.muted = true;

    const playRequest = video.play();

    if (playRequest) {
      playRequest.catch(() => {
        // Provide a way to play if the browser blocks autoplay.
        if (video.isConnected) video.controls = false;
      });
    }
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const visible =
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.5;

          videos.set(entry.target, visible);
          update(entry.target);
        });
      }, { threshold: [0, 0.5] })
    : null;

  function registerVideos() {
    // Clean up videos removed by the Shopify theme editor.
    videos.forEach((visible, video) => {
      if (!video.isConnected) {
        video.pause();
        observer?.unobserve(video);
        videos.delete(video);
      }
    });

    document.querySelectorAll(selector).forEach(video => {
      if (videos.has(video)) return;

      video.autoplay = false;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.pause();

      videos.set(video, !observer);

      if (observer) {
        observer.observe(video);
      } else {
        update(video);
      }
    });
  }

  document.addEventListener('visibilitychange', () => {
    videos.forEach((visible, video) => update(video));
  });

  reducedMotion.addEventListener('change', () => {
    videos.forEach((visible, video) => {
      video.pause();
      video.controls = false;
      update(video);
    });
  });

  document.addEventListener('shopify:section:load', registerVideos);
  document.addEventListener('shopify:section:unload', registerVideos);

  window.addEventListener('pagehide', () => {
    videos.forEach((visible, video) => video.pause());
  });

  window.addEventListener('pageshow', () => {
    registerVideos();
    videos.forEach((visible, video) => update(video));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerVideos, {
      once: true
    });
  } else {
    registerVideos();
  }
})();